import { CalendarDays, Map, Users, Bell, QrCode } from "lucide-react";

export default function PhoneMockup() {
    return (
        <div className="relative mx-auto w-[270px] floaty" data-testid="phone-mockup">
            <div className="absolute inset-0 -m-8 rounded-full opacity-50"
                style={{ background: "radial-gradient(circle, rgba(201,162,75,0.18), transparent 68%)" }} />
            <div className="relative rounded-[2.8rem] border border-[var(--line)] bg-gradient-to-b from-[#2A0A12] to-[#1C060C] p-2.5 shadow-[0_40px_90px_-30px_rgba(0,0,0,0.9)]">
                <div className="rounded-[2.2rem] overflow-hidden bg-[#1E060C] border border-[rgba(201,162,75,0.08)]">
                    <div className="flex justify-center pt-3 pb-2">
                        <div className="w-20 h-4 rounded-full bg-black/80 border border-[rgba(201,162,75,0.15)]" />
                    </div>
                    <div className="px-4 pt-1 pb-4">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-[0.5rem] tracking-[0.4em] text-[var(--gold)] uppercase">Startup</p>
                                <p className="font-display text-sm gold-text font-semibold tracking-wide">MAHABAZAAR</p>
                            </div>
                            <div className="w-7 h-7 rounded-full border border-[var(--line)] flex items-center justify-center">
                                <QrCode size={12} className="text-[var(--champagne)]" />
                            </div>
                        </div>
                        <div className="mt-4 rounded-lg border border-[rgba(201,162,75,0.18)] bg-[rgba(74,14,24,0.3)] p-3">
                            <p className="text-[0.5rem] tracking-[0.3em] uppercase text-[var(--gold)]">Live Now</p>
                            <p className="text-xs text-[var(--ivory)] mt-1 font-medium">MahaTalks — The Voices of Bharat</p>
                            <div className="mt-2 h-1 rounded-full bg-[rgba(201,162,75,0.15)] overflow-hidden">
                                <div className="h-full w-2/3 shimmer-line" />
                            </div>
                        </div>
                        <div className="mt-3 space-y-2">
                            {["PitchYatra — Round 1 · Climate", "Investor Speed Meets — Adda", "Startup Pods — Live Demos"].map((t, i) => (
                                <div key={t} className="flex items-center gap-2.5 rounded-lg border border-[rgba(201,162,75,0.1)] bg-[rgba(38,9,16,0.8)] p-2.5">
                                    <span className="w-1.5 h-1.5 rotate-45 bg-[var(--gold)] shrink-0" style={{ opacity: 1 - i * 0.25 }} />
                                    <p className="text-[0.62rem] text-[var(--ivory)]/75 truncate">{t}</p>
                                </div>
                            ))}
                        </div>
                        <div className="mt-3 grid grid-cols-3 gap-2">
                            {["Vote", "Map", "B2B"].map((t) => (
                                <div key={t} className="rounded-md border border-[rgba(201,162,75,0.12)] py-2 text-center text-[0.55rem] tracking-[0.2em] uppercase text-[var(--champagne)]/80">
                                    {t}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex items-center justify-around border-t border-[rgba(201,162,75,0.1)] py-3">
                        {[CalendarDays, Map, Users, Bell].map((Icon, i) => (
                            <Icon key={i} size={14} strokeWidth={1.5} className={i === 0 ? "text-[var(--gold)]" : "text-[var(--muted)]"} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
